import { BrowserModule } from '@angular/platform-browser';
import { NgModule, inject, provideAppInitializer } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MaterialModule} from "./app.materials";
import {AppRoutingModule} from "./app-routing.module";
import { NavComponent } from './nav/nav.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AuthService} from "./shared/auth.service";
import {KeycloakService} from "./shared/keycloak.service";
import {DataService} from "./shared/data.service";
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {TokenInterceptor} from "./shared/keycloak-token.iterceptor";
import {UtilService} from "./shared/util.service";
import {FilterAutocompleteComponent} from "./shared/filter-autocomplete/filter-autocomplete.component";
import {DragDropDirective} from "./shared/drag-drop.directive";
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { SearchPipe } from './shared/search.pipe';
import {UserService} from "./shared/user.service";
import {UsersComponent} from "./users/users.component";
import {UserEditComponent} from "./users/user-edit/user-edit.component";
import {ConfirmDialogComponent} from "./shared/confirm-dialog/confirm-dialog.component";
import { LogsComponent } from './logs/logs.component';
import {LogsService} from "./logs/logs.service";
import { NetworksComponent } from './networks/networks.component';
import {NetworkService} from "./networks/network.service";
import { CompaniesComponent } from './companies/companies.component';
import { SitesComponent } from './sites/sites.component';
import { MeasuresComponent } from './measures/measures.component';
import { UnitsComponent } from './units/units.component';
import { GeneralListComponent } from './shared/general-list/general-list.component';
import { NetworkEditComponent } from './networks/network-edit/network-edit.component';
import {SelectSearchComponent} from "./shared/select-search/select-search.component";
import {DeviceDialogComponent} from "./networks/network-edit/device-dialog/device-dialog.component";
import { DeviceComponent } from './device/device.component';
import { DeviceEditComponent } from './device/device-edit/device-edit.component';
import {DeviceService} from "./device/device.service";
import { DeviceTypeComponent } from './device-type/device-type.component';
import { DeviceTypeEditComponent } from './device-type/device-type-edit/device-type-edit.component';
import { DeviceAttributeDialogComponent } from './device-type/device-attribute-dialog/device-attribute-dialog.component';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from "@angular/material/snack-bar";
import { DeviceInfoDialogComponent } from './device/device-info-dialog/device-info-dialog.component';
import { YmlEditorComponent } from './yml/yml-editor/yml-editor.component';
import {YmlService} from "./yml/yml.service";
import { YmlListComponent } from './yml/yml-list/yml-list.component';
import { DeviceViewComponent } from './device/device-view/device-view.component';
import { DeviceLogComponent } from './device/device-log/device-log.component';
import { UnitEditComponent } from './units/unit-edit/unit-edit.component';
import { MeasureEditComponent } from './measures/measure-edit/measure-edit.component';
import {UnitsService} from "./units/units.service";
import {MeasureService} from "./measures/measure.service";
import { DeviceManageComponent } from './device/device-manage/device-manage.component';
import { DatapointDialogComponent } from './device/datapoint-dialog/datapoint-dialog.component';
import { DeviceAttributeComponent } from './device-attribute/device-attribute.component';
import { DeviceAttributeEditComponent } from './device-attribute/device-attribute-edit/device-attribute-edit.component';
import { DeviceQueryComponent } from './device/device-query/device-query.component';
import { DeviceMeasurementComponent } from './device/device-measurement/device-measurement.component';
import { ModbusrtuComponent } from './modbusrtu/modbusrtu.component';
import { ModbusrtuEditComponent } from './modbusrtu/modbusrtu-edit/modbusrtu-edit.component';
import {ModbusService} from "./modbusrtu/modbus.service";
import { SimpleListComponent } from './shared/simple-list/simple-list.component';
import { MeterOverviewComponent } from './device/meter-overview/meter-overview.component';
import { DeviceDataComponent } from './device/device-data/device-data.component';
import { LoggerMeasurementComponent } from './device/logger-measurement/logger-measurement.component';
import {LoaderService} from "./shared/loading-bar/loader.service";
import {LoadingBarComponent} from "./shared/loading-bar/loading-bar.component";
import { provideTranslateCompiler, TranslateModule } from '@ngx-translate/core';
import {AccessGuardService} from "./shared/access-guard.service";
import { InfluxComponent } from './influx/influx.component';
import {InfluxService} from "./influx/influx.service";
import {InterfaceService} from "./uploader/interface.service";
import {DndDirective} from "./shared/dnd.directive";
import { UploaderComponent } from './uploader/uploader.component';
import {SatPopoverModule} from "@ncstate/sat-popover";
import { RegisterPopoverComponent } from './device/device-measurement/register-popover/register-popover.component';
import { MeasureDialogComponent } from './device/device-measurement/measure-dialog/measure-dialog.component';
import { DeviceImpulseComponent } from './device/device-impulse/device-impulse.component';
import {ImpulseService} from "./device/device-impulse/impulse.service";
import {AxMpointSyncComponent} from "./sync/ax-mpoint-sync/ax-mpoint-sync.component";
import {SyncComponent} from "./sync/sync.component";
import {SyncService} from "./sync/ax-mpoint-sync/sync.service";
import { AttributelookupComponent } from './attributelookup/attributelookup.component';
import { CounterResetDialogComponent } from './device/device-impulse/counter-reset-dialog/counter-reset-dialog.component';
import {
    TranslateService,
    TranslatePipe,
    TranslateDirective
} from "@ngx-translate/core";
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
export function kcFactory(keycloakService: KeycloakService) {
  return () => keycloakService.init();
}
@NgModule({ declarations: [
        AppComponent,
        NavComponent,
        FilterAutocompleteComponent,
        DragDropDirective,
        HomeComponent,
        FooterComponent,
        SearchPipe,
        UsersComponent,
        UserEditComponent,
        ConfirmDialogComponent,
        LogsComponent,
        NetworksComponent,
        CompaniesComponent,
        SitesComponent,
        MeasuresComponent,
        UnitsComponent,
        GeneralListComponent,
        NetworkEditComponent,
        SelectSearchComponent,
        DeviceDialogComponent,
        DeviceComponent,
        DeviceEditComponent,
        DeviceTypeComponent,
        DeviceTypeEditComponent,
        DeviceAttributeDialogComponent,
        DeviceInfoDialogComponent,
        YmlEditorComponent,
        YmlListComponent,
        DeviceViewComponent,
        DeviceLogComponent,
        UnitEditComponent,
        MeasureEditComponent,
        DeviceManageComponent,
        DatapointDialogComponent,
        DeviceAttributeComponent,
        DeviceAttributeEditComponent,
        DeviceQueryComponent,
        DeviceMeasurementComponent,
        ModbusrtuComponent,
        ModbusrtuEditComponent,
        SimpleListComponent,
        MeterOverviewComponent,
        DeviceDataComponent,
        LoggerMeasurementComponent,
        LoadingBarComponent,
        InfluxComponent,
        DndDirective,
        UploaderComponent,
        RegisterPopoverComponent,
        MeasureDialogComponent,
        DeviceImpulseComponent,
        SyncComponent,
        AxMpointSyncComponent,
        AttributelookupComponent,
        CounterResetDialogComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        MaterialModule,
        SatPopoverModule,
        TranslateModule.forRoot({
            loader: provideTranslateHttpLoader({
                prefix: './assets/i18n/',
                suffix: '.json'
            }),
            //compiler: provideTranslateCompiler(CustomCompiler),
            fallbackLang: 'en'
        }),
        TranslatePipe,
        TranslateDirective], providers: [
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: 'noti-card'
            }
        },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        AuthService,
        KeycloakService,
        DataService,
        UtilService,
        UserService,
        LogsService,
        NetworkService,
        DeviceService,
        YmlService,
        UnitsService,
        MeasureService,
        ModbusService,
        LoaderService,
        AccessGuardService,
        InfluxService,
        InterfaceService,
        ImpulseService,
        SyncService,
        TranslateService,
        provideAppInitializer(() => {
        const initializerFn = (kcFactory)(inject(KeycloakService));
        return initializerFn();
      }),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
